import { TYPE } from "vue-toastification";
import { apiCall, logResponse } from "@/core/api";
import { showAlert } from "@/core/popup";

export async function getConfigurationsList(): Promise<any> {
  const resource = "configs";
  const response = await apiCall("GET", resource);
  if (response.code === 200) {
    return response.result;
  }
  logResponse(response);
  return undefined;
}

export async function getConfiguration(
  configurationId: string,
  level: string,
  ownerId: string
): Promise<any> {
  const endPoint = `configs/${configurationId}/${level}/${ownerId}`;
  const response = await apiCall("GET", endPoint);
  if (response.code === 200) {
    if (!response.result || response.result.length === 0) {
      console.warn("Configuration not found:", configurationId);
      return undefined;
    }
    return response.result[0];
  }
  logResponse(response);
  return undefined;
}

export async function deleteConfiguration(
  configurationId: string
): Promise<any> {
  const endPoint = `/configs/${configurationId}`;
  const response = await apiCall("DELETE", endPoint);
  if (response.code === 200) {
    return true;
  }
  logResponse(response);
  return false;
}

export async function addConfiguration(configuration: any): Promise<any> {
  const endPoint = "/configs/create";
  const response = await apiCall("POST", endPoint, configuration);

  if (response.code === 200) {
    return response.result;
  }

  if (response.code === 406) {
    showAlert(TYPE.WARNING, response.message);
    return undefined;
  }
  logResponse(response);
  return undefined;
}

export async function editConfiguration(configuration: any): Promise<any> {
  const endPoint = "configs";
  const response = await apiCall("POST", endPoint, configuration);
  if (response.code === 200) {
    return response.result;
  }
  logResponse(response);
  return undefined;
}

// New methods following the pattern from settings.service.ts
export async function getConfigurationSettings(
  type: string,
  ownerId?: string
): Promise<any> {
  const endPoint = `configs/level/${type}/owner/${ownerId}`;
  try {
    const response = await apiCall("GET", endPoint);
    if (response.code === 200) {
      return response.result;
    }
    logResponse(response);
    return undefined;
  } catch (error) {
    console.error("API Error:", error);
    return undefined;
  }
}

export async function getAllConfigurations(): Promise<any> {
  const endPoint = "configs/public";
  try {
    const response = await apiCall("GET", endPoint);
    if (response.code === 200) {
      return response.result;
    }
    logResponse(response);
    return undefined;
  } catch (error) {
    console.error("API Error:", error);
    return undefined;
  }
}

export async function updateConfigurationSettings(data: any): Promise<any> {
  const endPoint = "configs";
  const response = await apiCall("PUT", endPoint, data);
  logResponse(response);
  return response;
}
